import React from 'react'
import "./Button.css"

const SecondaryBtn = ({ iconPosition = "left", label = "", handleClick = null, icon = null, px = "px-[20px]", py = "py-[10px]", disabled = false }) => {
    return (
        <div>
            <button disabled={disabled} className={`disabled:cursor-not-allowed secondaryBtn ${px} ${py}`} onClick={handleClick}>
                {icon && iconPosition === "left" && (
                    <span className="flex items-center">{icon}</span>
                )}

                {label && <span>{label}</span>}

                {icon && iconPosition === "right" && (
                    <span className="flex items-center">{icon}</span>
                )}

            </button>
        </div>
    )
}

export default SecondaryBtn